


























































import { Vue, Component } from "vue-property-decorator";

@Component
export default class Nav extends Vue {
  updateLang(lang: string) {
    this.$router.push({ name: this.$route.name ? this.$route.name : 'home', params: { lang: lang } });
  }
}
